import { render, staticRenderFns } from "./PositionAreaInputConfig.vue?vue&type=template&id=ab327cf0&scoped=true"
import script from "./PositionAreaInputConfig.vue?vue&type=script&lang=js"
export * from "./PositionAreaInputConfig.vue?vue&type=script&lang=js"
import style0 from "./PositionAreaInputConfig.vue?vue&type=style&index=0&id=ab327cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab327cf0",
  null
  
)

export default component.exports